import { useState, useEffect } from 'react'
import InputNumberDiwa from './InputNumberDiwa'
import { CheckOutlined } from '@ant-design/icons'

function NumericInputWithCheck(props) {
  const [inputValue, setInputValue] = useState(props.columnTotal)

  useEffect(() => {
    setInputValue(props.columnTotal)
  }, [props.columnTotal])

  return (
    <div className='d-flex justify-space-around'>
      <InputNumberDiwa
        className='numeric-input input-check ma-0'
        min={0}
        step={1}
        value={inputValue}
        onChange={setInputValue}
        onValueConfirm={props.onEnterConfirm}
        type='number'
      />
      <CheckOutlined
        className='numeric-input confirm-amount mr-0'
        onClick={e => {
          props.onInputConfirm(inputValue)
        }}
      />
    </div>
  )
}

export default NumericInputWithCheck
